<template>
  <v-container fluid>
    <v-data-table
      :headers="headers"
      :items="valid_items"
      item-key="url_id"
      sort-by="domain_name"
      class="elevation-1"
      dense
      hide-default-footer
    >
      <template v-slot:top>
        <v-toolbar>
          <!-- <v-spacer></v-spacer> -->
          <v-toolbar-title class="display-1 ms-3">
            Valid Urls
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            color="blue-grey lighten-3"
            class="me-16 black--text"
            large
            @click="saveUrls(null)"
            :disabled="!valid_items.length"
            :loading="loading"
          >
            <v-icon>save</v-icon>
            Save ALL
          </v-btn>
          <!-- <v-spacer></v-spacer> -->
          <!-- <v-divider
          class="mx-4"
          inset
          vertical
        ></v-divider> -->
        </v-toolbar>
      </template>
      <template v-slot:item.variation="{ item }">
        {{ (!!item.variation.variation_text) ? item.variation.variation_text : 'No variation' }}
      </template>
      <template v-slot:item.url="{ item }">
        <span class="">
          {{ item.url }}
        </span>
      </template>
      <template v-slot:item.actions="{ item }">
        <div class="d-flex flex-row justify-center">
          <v-btn plain>
            <v-icon
              class="red--text text--darken-2"
              large
              @click="deleteItem(item)"
            >
              mdi-delete
            </v-icon>
          </v-btn>
          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>
          <v-btn plain>
            <v-icon
              class="mx-3 blue-grey--text text--lighten-3"
              large
              @click="saveUrls(item)"
            >
              save
            </v-icon>
          </v-btn>
        </div>
      </template>
    </v-data-table>
    <v-snackbar
      v-model="snackbar.show"
      :timeout="3000"
      tile
      :color="snackbar.success ? 'success' : 'warning'"
    >
      {{ snackbar.text }}
    </v-snackbar>
  </v-container>
</template>

<script>
/* eslint-disable */
import { exractProductDomains, eliminate_negative_ids } from "@/helpers/functions"

export default {
  name: "ValidsTable",
  data: () => ({
    snackbar: {
      show: false,
      text: "My timeout is set to 2000.",
      success: true,
    },
    headers: [
      {
        text: "Variation",
        align: "start",
        sortable: false,
        value: "variation",
        class: "subtitle-1",
      },
      { text: "Domain", value: "domain_name", class: "subtitle-1" },
      { text: "Url", value: "url", class: "subtitle-1", align: "center" },
      { text: "Actions", value: "actions", class: "subtitle-1", align: "center", sortable: false },
    ],
  }),

  computed: {
    valid_items() {
      const valids = [];
      this.$store.state.productionModule.valid_domains_urls.forEach((x) => {
        x.domain_urls.forEach((y) => {
          if(y.url != ""){
            valids.push({
              domain_id: x.domain_id,
              domain_name: x.domain_name,
              url_id: y.url_id,
              url: y.url,
              variation: y.variation,
            });
          }
        });
      });
      return valids;
    },
    loading: {
      get() {
        return this.$store.state.productionModule.loading;
      },
      set(value) {
        const data = { value, key: "loading" };
        this.$store.commit("productionModule/SET_PRODUCTION_STATE", data);
      },
    },
    // valid_items() {
    //   return this.$store.state.productionModule.valid_domains_urls.map(
    //     (x) => (x.domain_urls.map(
    //         (y) => ({
    //             domain_id: x.domain_id,
    //             domain_name: x.domain_name,
    //             url_id: y.url_id,
    //             url: y.url,
    //             variation: y.variation,
    //         })
    //     ))
    //   );
    // }
  },

  methods: {
    deleteItem(item) {
      console.log("matching item", item);
      this.$store.commit("productionModule/REMOVE_VALID_DOMAIN_URLS", {
        url_id: item.url_id,
        domain_id: item.domain_id,
      });
    },
    saveUrls(item = null) {
      this.loading = true;
      const valids =
        item
          ? this.find_valid_domain_urls(item)
          : this.$store.state.productionModule.valid_domains_urls;
      console.log('valids for save', valids);
      const save_all_data = {
        task: "addUrlProduct",
        payload: {
          product_id: this.$store.state.productionModule.selected_product.id,
          urls: {
            product_domains: eliminate_negative_ids(JSON.parse(JSON.stringify(valids))),
          },
          // $domains = $this->post->payload->urls->product_domains;
        },
      };
      console.log("save all - api data", save_all_data);
      this.$store
        .dispatch("productionModule/general_api", save_all_data)
        .then((res) => {
          this.loading = false;
          if (res.data.payload.status == "success") {
            this.snackbar.text = "Successfully saved urls";
            this.snackbar.show = true;
            if(item){
              const data = {
                key: 'selected_product.specs.product_domains',
                value: valids,
              }  // add to selected_product
              this.$store.commit('productionModule/PUSH_PRODUCTION_STATE', data)
              this.deleteItem(item); // delete from valids
            } else {
              [...this.valid_items].forEach( item => {
                this.deleteItem(item);
              }); // delete all from valids and reload product
              this.$emit("success_save_all_new_urls");
            }
          }
        }
      );
    },
    find_valid_domain_urls(item) {
      let item_found = [];
      const valids = JSON.parse(JSON.stringify(this.$store.state.productionModule.valid_domains_urls));
      item_found.push(valids.find(v => v.domain_id == item.domain_id));
      item_found[0].domain_urls = [item_found[0].domain_urls.find(u => u.url_id == item.url_id)];
      console.log('item_found', item_found);
      return item_found;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/production/N_ValidsTable.vue